import { Arrangement } from 'redux/PDP/arrangement/types/arrangement.types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type State = {
  arrangements: Arrangement[];
  validArrangementIds: string[];
};

const initialState: State = {
  arrangements: [],
  validArrangementIds: [],
};

const slice = createSlice({
  name: 'catering-arrangements',
  reducers: {
    setArrangements: (state, action: PayloadAction<Arrangement[]>) => {
      state.arrangements = action.payload;
    },
    setValidArrangementIds: (state, action: PayloadAction<string[]>) => {
      state.validArrangementIds = action.payload;
    },
    clearArrangements: (state) => {
      state.arrangements = [];
      state.validArrangementIds = [];
    },
  },
  initialState,
});

export const cateringArrangementsReducer = slice.reducer;
export const { setArrangements } = slice.actions;
